/**
 * How to reach InBrief. The contact page reads everything from here.
 *
 * There is deliberately no telephone number. An unanswered number is worse
 * than no number: it invites a call that goes nowhere and reads as a business
 * that has stopped trading. Email only, with a stated response time, is an
 * honest promise for an organisation this size.
 */
export const CONTACT = {
  email: 'Louis@inbrief.health',
  /** Shown as the response commitment. Keep it to something you will meet. */
  responseTime: 'within one working day',
  /**
   * A scheduling link, if you use one — Calendly, Cal.com, a Teams booking
   * page. Left empty deliberately: empty hides the button, where a wrong value
   * shows a button that goes nowhere.
   */
  bookingUrl: '',
} as const;

export const hasBookingLink = CONTACT.bookingUrl.length > 0;

/**
 * Builds a `mailto:` from the enquiry form.
 *
 * A form that posts to a server InBrief does not have would either need a
 * third-party form service or would silently discard what somebody typed.
 * This hands the message to their own mail client with everything filled in:
 * nothing is lost, the sender keeps a copy in their sent items, and there is
 * no doubt about whether it arrived.
 */
export interface Enquiry {
  name: string;
  organisation: string;
  email: string;
  practices: string;
  interest: string;
  message: string;
}

export function enquiryMailto(enquiry: Enquiry): string {
  const subject = `Demo request — ${enquiry.organisation || 'InBrief enquiry'}`;
  const body = [
    `Name: ${enquiry.name}`,
    `Organisation: ${enquiry.organisation}`,
    `Email: ${enquiry.email}`,
    `Practices: ${enquiry.practices}`,
    `Interested in: ${enquiry.interest}`,
    '',
    enquiry.message,
  ].join('\n');

  return `mailto:${CONTACT.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
